const ROUTE_NAME_MAP = {
  '/': 'HomePage',
  '/about': 'AboutPage',
  '/resources': 'ResourcesPage',
  '/resources/glp1-bridge/recording': 'Glp1BridgeRecordingPage',
  '/resources/glp1-bridge/guide': 'MedicareGlp1BridgeGuidePage',
  '/resources/glp1-bridge/assistant': 'Glp1BridgeAssistantPage',
  '/resources/glp1-bridge': 'Glp1BridgeHubPage',
  '/resources/newsletter': 'NewsletterArchivePage',
  '/resources/newsletter/1026': 'NewsletterOctober2026Page',
  '/resources/newsletter/0826': 'NewsletterAugust2026Page',
  '/resources/newsletter/subscribed': 'NewsletterSubscribedPage',
  '/glp1-bridge': 'MedicareGlp1BridgeRedirect',
  '/m3p': 'MedicationCalculatorPage',
  '/resources/m3p': 'M3PPage',
  '/news': 'NewsPage',
  '/signup': 'SignupPage',
  '/privacy-policy': 'PrivacyPolicyPage',
  '/terms-of-use': 'TermsOfUsePage',
};

const ROUTE_NAME_LIMIT = 100;
const PREFIX_BOUNDARY_CHARS = new Set(['/', '-', '_', '%']);
const ROUTE_PREFIX_ENTRIES = Object.entries(ROUTE_NAME_MAP).sort(
  ([leftPath], [rightPath]) => rightPath.length - leftPath.length
);

function getPathname() {
  if (typeof window === 'undefined' || !window.location) {
    return '';
  }
  return window.location.pathname || '';
}

function getRouteNameFromKnownPrefix(routePath = '') {
  for (const [knownPath, routeName] of ROUTE_PREFIX_ENTRIES) {
    if (!routePath.startsWith(knownPath)) {
      continue;
    }

    const suffix = routePath.slice(knownPath.length);
    if (!suffix || PREFIX_BOUNDARY_CHARS.has(suffix[0])) {
      return routeName;
    }
  }

  return '';
}

function buildFallbackRouteName(routePath = '') {
  const normalizedPath = String(routePath || '').trim();
  if (!normalizedPath) {
    return '';
  }

  const pathSegments = normalizedPath.split('/').filter(Boolean).slice(0, 2);
  const routeBucket = pathSegments.length ? `/${pathSegments.join('/')}` : normalizedPath;

  return `UnknownRoute:${routeBucket}`.slice(0, ROUTE_NAME_LIMIT);
}

export function getCurrentRouteMeta() {
  const routePath = getPathname();
  const routeName =
    ROUTE_NAME_MAP[routePath] ||
    getRouteNameFromKnownPrefix(routePath) ||
    buildFallbackRouteName(routePath);

  return {
    routePath,
    routeName,
  };
}
